import {createSlice, nanoid} from '@reduxjs/toolkit';
import { ProjectType } from '../types/project';

interface ProjectState {
  id: string;
  name: string;
  path: string;
  type: ProjectType;
  uniqueSession: string;
  configVersion: string;
}

export const defaultProjectTitle = 'project-settings.untitled-project';

// Current config version
export const currentConfigVersion = "3.21.0";

// Not possible to upgrade below this version
export const minimumConfigVersion = "3.4.0";

export const projectSlice = createSlice({
  name: 'project',
  initialState: {
    id: nanoid(),
    name: defaultProjectTitle,
    path: '',
    type: ProjectType.Standard,
    uniqueSession: nanoid(),
    configVersion: currentConfigVersion
  } as ProjectState,
  reducers: {
    updateProjectID: (state, action) => {
      state.id = action.payload;
    },
    updateSessionID: (state, action) => {
      state.uniqueSession = action.payload;
    },
    updateProjectName: (state, action) => {
      state.name = action.payload;
    },
    changePath: (state, action) => {
      state.path = action.payload;
    }
  }
});

export const {
  updateProjectID,
  updateSessionID,
  updateProjectName,
  changePath
} = projectSlice.actions;

export default projectSlice.reducer;

export const selectProjectID = (state): string => state.project.id;
export const selectProjectName = (state): string => state.project.name;
export const selectProjectType = (state): ProjectType => state.project.type;
export const selectSessionID = (state): string => state.project.uniqueSession;